<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-expansion-panel-content {
  padding: 0px !important;
}
.rounded-card {
  border-radius: 35px;
}
</style>
<template>
  <div>
    <v-card color="grey lighten-4" flat height="70px" tile>
      <v-toolbar>
        <v-toolbar-title>Career Report</v-toolbar-title>

        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>

    <v-row class="mb-2 mt-2 ml-1">
      <v-col cols="4">
        <v-card class="rounded-card">
          <v-card-title
            >Upcoming Promotions This &nbsp;&nbsp; Week</v-card-title
          >
          <v-card-subtitle
            >Total Number of workers that have a promotion this
            week.</v-card-subtitle
          >

          <v-card-actions class="justify-center">
            <v-btn icon>
              <v-icon style="font-size: 45px">mdi-transfer-up</v-icon>
            </v-btn>
            <h1>{{ totalWeek }}</h1>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="4">
        <v-card class="rounded-card">
          <v-card-title
            >Upcoming Promotions This &nbsp;&nbsp; Month</v-card-title
          >
          <v-card-subtitle
            >Total Number of workers that have a promotion this
            week.</v-card-subtitle
          >
          <v-card-actions class="justify-center">
            <v-btn icon>
              <v-icon style="font-size: 45px">mdi-transfer-up</v-icon>
            </v-btn>
            <h1>{{ totalMonth }}</h1>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="4">
        <v-card class="rounded-card">
          <v-card-title
            >Upcoming Promotions This &nbsp; &nbsp; Year</v-card-title
          >
          <v-card-subtitle
            >Total Number of workers that have a promotion this
            week.</v-card-subtitle
          >
          <v-card-actions class="justify-center">
            <v-btn icon>
              <v-icon style="font-size: 45px">mdi-transfer-up</v-icon>
            </v-btn>
            <h1>{{ totalYear }}</h1>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-app>
      <v-expansion-panels focusable class="pa-2 ml-2 mr-2">
        <v-expansion-panel class="mb-2">
          <v-expansion-panel-header
            ><h2>Upcoming Promotions</h2></v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-toolbar color="primary" dark flat>
              <template>
                <v-tabs v-model="tabs" centered>
                  <v-tab @click="changeExcel('week')">
                    <h3>This week</h3>
                  </v-tab>

                  <v-tab @click="changeExcel('month')">
                    <h3>This Month</h3>
                  </v-tab>

                  <v-tab @click="changeExcel('year')">
                    <h3>This Year</h3>
                  </v-tab>
                  <vue-excel-xlsx
                    :data="reportDataForExcel"
                    :columns="columns"
                    :file-name="
                      new Date().toISOString().slice(0, 10) + '_report'
                    "
                    :file-type="'xlsx'"
                    :sheet-name="'sheetname'"
                  >
                    <v-btn  color="success" class="ma-2 white--text">
                      Export in Excel
                      <v-icon right dark> mdi-file-excel </v-icon>
                    </v-btn>
                  </vue-excel-xlsx>
                </v-tabs>
              </template>
            </v-toolbar>

            <v-tabs-items v-model="tabs">
               <!-- This Week -->
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="headers"
                    :items="reportDataWeek"
                    ref="filteredTable"
                    :loading="loading"
                    loading-text="Loading... Please wait"
                  >
                    <template v-slot:top>
                      <v-divider class="mb-2"></v-divider>
                      <v-container>
                        <v-row>
                          <v-col cols="4">
                            <v-row class="pa-1">
                              <v-text-field
                                v-model="firstNameFilterValue"
                                type="text"
                                label="First Name"
                              ></v-text-field>
                            </v-row>
                          </v-col>

                          <v-col cols="4">
                            <v-row class="pa-1">
                              <v-text-field
                                v-model="lastNameFilterValue"
                                type="text"
                                label="Last Name"
                              ></v-text-field>
                            </v-row>
                          </v-col>
                          <v-col cols="4">
                            <v-row class="pa-1">
                              <v-text-field
                                v-model="grandNameFilterValue"
                                type="text"
                                label="Grandfather's Name"
                              ></v-text-field>
                            </v-row>
                          </v-col>

                          <v-col cols="2">
                            <v-row class="pa-1">
                              <v-select
                                clearable
                                :items="genderFilterItem"
                                v-model="genderFilterValue"
                                label="Gender"
                              ></v-select>
                            </v-row>
                          </v-col>

                          <v-col cols="3">
                            <v-row class="pa-1">
                              <v-autocomplete
                                clearable
                                :items="facilityFilterItem"
                                v-model="selectedFacility"
                                label="Facility"
                              ></v-autocomplete>
                            </v-row>
                          </v-col>
                          <v-col cols="2">
                            <v-row class="pa-1">
                              <v-select
                                clearable
                                :items="empStatusFilterItem"
                                v-model="selectedEmpStatus"
                                label="Employment Status"
                              ></v-select>
                            </v-row>
                          </v-col>

                          <v-col cols="2">
                            <v-row class="pa-1">
                              <v-select
                                clearable
                                :items="educationLevelFilterItem"
                                v-model="selectedEducationLevel"
                                label="Education Level"
                              ></v-select>
                            </v-row>
                          </v-col>
                          <v-col cols="3">
                            <v-row class="pa-1">
                              <v-select
                                clearable
                                :items="jobTitleFilterItem"
                                v-model="selectedJobTitle"
                                label="Job Title"
                              ></v-select>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <!-- This Month -->
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="headers"
                    :items="reportDataMonth"
                    ref="filteredTable"
                    :loading="loading"
                    loading-text="Loading... Please wait"
                  >
                    <template v-slot:top>
                      <v-divider class="mb-2"></v-divider>
                      <v-container>
                        <v-row>
                          <v-col cols="4">
                            <v-row class="pa-1">
                              <v-text-field
                                v-model="firstNameFilterValue"
                                type="text"
                                label="First Name"
                              ></v-text-field>
                            </v-row>
                          </v-col>

                          <v-col cols="4">
                            <v-row class="pa-1">
                              <v-text-field
                                v-model="lastNameFilterValue"
                                type="text"
                                label="Last Name"
                              ></v-text-field>
                            </v-row>
                          </v-col>
                          <v-col cols="4">
                            <v-row class="pa-1">
                              <v-text-field
                                v-model="grandNameFilterValue"
                                type="text"
                                label="Grandfather's Name"
                              ></v-text-field>
                            </v-row>
                          </v-col>

                          <v-col cols="2">
                            <v-row class="pa-1">
                              <v-select
                                clearable
                                :items="genderFilterItem"
                                v-model="genderFilterValue"
                                label="Gender"
                              ></v-select>
                            </v-row>
                          </v-col>

                          <v-col cols="3">
                            <v-row class="pa-1">
                              <v-autocomplete
                                clearable
                                :items="facilityFilterItem"
                                v-model="selectedFacility"
                                label="Facility"
                              ></v-autocomplete>
                            </v-row>
                          </v-col>
                          <v-col cols="2">
                            <v-row class="pa-1">
                              <v-select
                                clearable
                                :items="empStatusFilterItem"
                                v-model="selectedEmpStatus"
                                label="Employment Status"
                              ></v-select>
                            </v-row>
                          </v-col>

                          <v-col cols="2">
                            <v-row class="pa-1">
                              <v-select
                                clearable
                                :items="educationLevelFilterItem"
                                v-model="selectedEducationLevel"
                                label="Education Level"
                              ></v-select>
                            </v-row>
                          </v-col>
                          <v-col cols="3">
                            <v-row class="pa-1">
                              <v-select
                                clearable
                                :items="jobTitleFilterItem"
                                v-model="selectedJobTitle"
                                label="Job Title"
                              ></v-select>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
               <!-- This Year -->
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="headers"
                    :items="reportDataYear"
                    ref="filteredTable"
                    :loading="loading"
                     v-model="selectedYearReport"
                      show-select
                    loading-text="Loading... Please wait"
                  >
                    <template v-slot:top>
                      <v-divider class="mb-2"></v-divider>
                      <v-container>
                        <v-row>
                          <v-col cols="4">
                            <v-row class="pa-1">
                              <v-text-field
                                v-model="firstNameFilterValue"
                                type="text"
                                label="First Name"
                              ></v-text-field>
                            </v-row>
                          </v-col>

                          <v-col cols="4">
                            <v-row class="pa-1">
                              <v-text-field
                                v-model="lastNameFilterValue"
                                type="text"
                                label="Last Name"
                              ></v-text-field>
                            </v-row>
                          </v-col>
                          <v-col cols="4">
                            <v-row class="pa-1">
                              <v-text-field
                                v-model="grandNameFilterValue"
                                type="text"
                                label="Grandfather's Name"
                              ></v-text-field>
                            </v-row>
                          </v-col>

                          <v-col cols="2">
                            <v-row class="pa-1">
                              <v-select
                                clearable
                                :items="genderFilterItem"
                                v-model="genderFilterValue"
                                label="Gender"
                              ></v-select>
                            </v-row>
                          </v-col>

                          <v-col cols="3">
                            <v-row class="pa-1">
                              <v-autocomplete
                                clearable
                                :items="facilityFilterItem"
                                v-model="selectedFacility"
                                label="Facility"
                              ></v-autocomplete>
                            </v-row>
                          </v-col>
                          <v-col cols="2">
                            <v-row class="pa-1">
                              <v-select
                                clearable
                                :items="empStatusFilterItem"
                                v-model="selectedEmpStatus"
                                label="Employment Status"
                              ></v-select>
                            </v-row>
                          </v-col>

                          <v-col cols="2">
                            <v-row class="pa-1">
                              <v-select
                                clearable
                                :items="educationLevelFilterItem"
                                v-model="selectedEducationLevel"
                                label="Education Level"
                              ></v-select>
                            </v-row>
                          </v-col>
                          <v-col cols="3">
                            <v-row class="pa-1">
                              <v-select
                                clearable
                                :items="jobTitleFilterItem"
                                v-model="selectedJobTitle"
                                label="Job Title"
                              ></v-select>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header
            ><h2>
              Terminated Positions/Career History/
            </h2></v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <h4>
              Select from the available filters for more specific result

              <v-btn
                class="mb-4 mt-1"
                tile
                color="primary"
                v-on:click="resetFilter"
              >
                <v-icon left> mdi-refresh </v-icon>
                Clear Filters
              </v-btn>
            </h4>

            <v-data-table
              :headers="headers"
              :items="historyData"
              ref="filteredTable"
              :loading="loading"
              loading-text="Loading... Please wait"
            >
              <template v-slot:top>
                <v-divider class="mb-2"></v-divider>
                <v-container>
                  <v-row>
                    <v-col cols="4">
                      <v-row class="pa-1">
                        <v-text-field
                          v-model="firstNameFilterValue"
                          type="text"
                          label="First Name"
                        ></v-text-field>
                      </v-row>
                    </v-col>

                    <v-col cols="4">
                      <v-row class="pa-1">
                        <v-text-field
                          v-model="lastNameFilterValue"
                          type="text"
                          label="Last Name"
                        ></v-text-field>
                      </v-row>
                    </v-col>
                    <v-col cols="4">
                      <v-row class="pa-1">
                        <v-text-field
                          v-model="grandNameFilterValue"
                          type="text"
                          label="Grandfather's Name"
                        ></v-text-field>
                      </v-row>
                    </v-col>

                    <v-col cols="2">
                      <v-row class="pa-1">
                        <v-select
                          clearable
                          :items="genderFilterItem"
                          v-model="genderFilterValue"
                          label="Gender"
                        ></v-select>
                      </v-row>
                    </v-col>

                    <v-col cols="3">
                      <v-row class="pa-1">
                        <v-autocomplete
                          clearable
                          :items="facilityFilterItem"
                          v-model="selectedFacility"
                          label="Facility"
                        ></v-autocomplete>
                      </v-row>
                    </v-col>
                    <v-col cols="2">
                      <v-row class="pa-1">
                        <v-select
                          clearable
                          :items="empStatusFilterItem"
                          v-model="selectedEmpStatus"
                          label="Employment Status"
                        ></v-select>
                      </v-row>
                    </v-col>

                    <v-col cols="2">
                      <v-row class="pa-1">
                        <v-select
                          clearable
                          :items="educationLevelFilterItem"
                          v-model="selectedEducationLevel"
                          label="Education Level"
                        ></v-select>
                      </v-row>
                    </v-col>
                    <v-col cols="3">
                      <v-row class="pa-1">
                        <v-select
                          clearable
                          :items="jobTitleFilterItem"
                          v-model="selectedJobTitle"
                          label="Job Title"
                        ></v-select>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-app>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      columns: [
        {
          label: "Id",
          field: "practitioner_id",
        },
        {
          label: "First Name",
          field: "first_name",
        },
        {
          label: "Last Name",
          field: "last_name",
        },
        {
          label: "Gender",
          field: "gender",
        },
        {
          label: "Employment Status",
          field: "employment_status",
        },
        {
          label: "Profession Caategory",
          field: "profession_category",
        },
        {
          label: "Start Date",
          field: "end_date",
        },
        {
          label: "Evaluator Name",
          field: "evaluator_name",
        },

        {
          label: "Facility Name",
          field: "facility",
        },
        {
          label: "Fisacal Year",
          field: "fiscal_year",
        },
        {
          label: "Career Length",
          field: "career_length",
        },
        {
          label: "Job Title",
          field: "job_title",
        },
        {
          label: "Education Level",
          field: "education_level",
        },
      ],
      loading: true,
      min: 0,
      max: 100,
      range: [20, 100],
      genderFilterItem: ["Male", "Female"],
      facilityFilterItem: [],
      empStatusFilterItem: [],
      educationLevelFilterItem: [],
      jobTitleFilterItem: [],
      fYearFilterItem: [],
      selectedFacility: "",
      selectedJobTitle: "",
      selectedEmpStatus: "",
      selectedFiscalYear: "",
      selectedEducationLevel: "",
      genderFilterValue: "",
      reportFilterValue: "",
      evaluationStartFilterValue: "",
      evaluationEndFilterValue: "",
      firstNameFilterValue: "",
      evaluatorNameFilterValue: "",
      fYearFilterValue: "",
      lastNameFilterValue: "",
      grandNameFilterValue: "",
      historyData: [],
      reportDataWeek: [],
      reportDataMonth: [],
      reportDataYear: [],
      selectedYearReport: [],
      tabs: null,
      totalWeek: 0,
      totalMonth: 0,
      totalYear: 0,
      reportDataForExcel: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "Id",
          align: "left",
          sortable: true,
          value: "practitioner_id",
        },
        {
          text: "First Name",
          align: "left",
          sortable: true,
          value: "first_name",
          filter: this.firstNameFilter,
        },
        {
          text: "Last Name",
          align: "left",
          sortable: true,
          value: "last_name",
          filter: this.lastNameFilter,
        },
        {
          text: "Grand Fathers Name",
          align: "left",
          sortable: true,
          value: "grandfather_name",
          filter: this.grandNameFilter,
        },

        {
          text: "Gender",
          value: "gender",
          filter: this.genderFilter,
        },
        {
          text: "Employment Status",
          value: "employment_status",
          filter: this.filterEmpStatus,
        },
        {
          text: "Hire Date",
          value: "start_date",
          filter: this.startDateFilter,
        },
        {
          text: "End Date",
          value: "end_date",
          filter: this.endDateFilter,
        },

        {
          text: "Fiscal Year",
          value: "fiscal_year",
          filter: this.fYearFilter,
        },
        {
          text: "Career Length(Years)",
          value: "career_length",
          filter: this.careerLengthFilter,
        },
        {
          text: "Facility Name",
          value: "facility",
          filter: this.filterFacility,
        },
        {
          text: "Job Start Date",
          value: "job_start_date",
        },
        {
          text: "Job Title",
          value: "job_title",
          filter: this.filterJobTitle,
        },
        {
          text: "Education Level",
          value: "education_level",
          filter: this.filterEducationLevel,
        },
      ];
    },
  },
  created: function () {
    this.setupData();
  },
  methods: {
    selectedYear() {
     console.log('shikak');
    },


    resetFilter() {
      this.reportData = [];
      this.reportDataForExcel = [];
      this.genderFilterValue = "";
      this.selectedEmpStatus = "";
      this.firstNameFilterValue = "";
      this.fYearFilterValue = "";
      this.evaluationStartfilterValue = "";
      this.evaluatorNameFilterValue = "";
      this.grandNameFilterValue = "";
      this.lastNameFilterValue = "";
      this.selectedEducationLevel = "";
      this.selectedFacility = "";
      this.selectedJobTitle = "";

      this.setupData();
    },
    setupData() {
      let url = "/config/reports/getReportData";

      //Get the data from database
      axios.get(url).then((response) => {
        if (response.data == "no data") {
          this.loading = false;
        } else if (response.data) {
          this.facilityFilterItem = response.data.facilities;
          this.jobTitleFilterItem = response.data.jobTitles;
          this.educationLevelFilterItem = response.data.educationLevel;
          this.empStatusFilterItem = response.data.employmentStatus;

          response.data.tableData.forEach((element) => {
            //make dates human readable format
            element.start_date = new Date(
              element.start_date
            ).toLocaleDateString();
            if (element.end_date) {
              element.end_date = new Date(
                element.end_date
              ).toLocaleDateString();
            }
            element.job_start_date = new Date(
              element.job_start_date
            ).toLocaleDateString();
            if (element.end_date == null) {
              var today = new Date();
              var startDate = new Date(element.job_start_date);
              let careerLength =
                today.getFullYear() -
                new Date(element.job_start_date).getFullYear();
              element.career_length = careerLength;

              var diffWeek = this.diffCalculation(
                Date.UTC(today.getMonth(), today.getDate()),
                Date.UTC(startDate.getMonth(), startDate.getDate())
              );
              var diffMonth = this.diffCalculation(
                Date.UTC(today.getMonth()),
                Date.UTC(startDate.getMonth())
              );

              if (careerLength >= 1 && diffWeek <= 7 && diffMonth == 0) {
                this.reportDataWeek.push(element);
                this.reportDataForExcel.push(element);
                this.totalWeek++;
              }

              if (careerLength >= 1 && diffMonth == 0) {
                this.reportDataMonth.push(element);
                this.reportDataForExcel.push(element);
                this.totalMonth++;
              }

              if (careerLength >= 1) {
                this.reportDataYear.push(element);
                this.reportDataForExcel.push(element);
                this.totalYear++;
              }

              this.reportDataForExcel.push(element);
              this.loading = false;
            } else this.historyData.push(element);
          });
        }
      });
    },
    changeExcel(type) {
      if (type == "week") {
        this.reportDataForExcel = [];

        this.reportDataForExcel = this.reportDataWeek;
      }
      if (type == "month") {
        this.reportDataForExcel = [];

        this.reportDataForExcel = this.reportDataMonth;
      }
      if (type == "year") {
        this.reportDataForExcel = [];

        this.reportDataForExcel = this.reportDataYear;
      }
    },
    diffCalculation(startDate, endDate) {
      const _MS_PER_DAY = 1000 * 60 * 60 * 24;
      return Math.floor((startDate - endDate) / _MS_PER_DAY);
    },

    firstNameFilter(value) {
      if (!this.firstNameFilterValue) {
        return true;
      }
      return value
        .toLowerCase()
        .includes(this.firstNameFilterValue.toLowerCase());
    },
    lastNameFilter(value) {
      if (!this.lastNameFilterValue) {
        return true;
      }
      return value
        .toLowerCase()
        .includes(this.lastNameFilterValue.toLowerCase());
    },
    grandNameFilter(value) {
      if (!this.grandNameFilterValue) {
        return true;
      }
      return value
        .toLowerCase()
        .includes(this.grandNameFilterValue.toLowerCase());
    },
    genderFilter(value) {
      if (!this.genderFilterValue) {
        return true;
      }

      return value.toLowerCase() === this.genderFilterValue.toLowerCase();
    },
    fYearFilter(value) {
      if (!this.fYearFilterValue) {
        return true;
      }

      return value.toLowerCase() === this.fYearFilterValue.toLowerCase();
    },
    filterEducationLevel(value) {
      if (!this.selectedEducationLevel) {
        return true;
      }

      return value.toLowerCase() === this.selectedEducationLevel.toLowerCase();
    },
    filterFacility(value) {
      if (!this.selectedFacility) {
        return true;
      }
      return value.toLowerCase() === this.selectedFacility.toLowerCase();
    },

        filterJobTitle(value) {
      if (!this.selectedJobTitle) {
        return true;
      }
      // this.reportDataForExcel=value.toLowerCase() === this.selectedJobTitle.toLowerCase();
 
      return value.toLowerCase() === this.selectedJobTitle.toLowerCase();
    },
    filterEmpStatus(value) {
      if (!this.selectedEmpStatus) {
        return true;
      }
      return value.toLowerCase() === this.selectedEmpStatus.toLowerCase();
    },
  },
};
</script>